import { SettingScopesEnum } from "@simbelapp/order-sdk";
import type { IIndexHeader } from "~/utils/interfaces/table-interfaces";

type CatalogRowActionsEmit = {
  (event: "edit", id: string): void;
  (event: "duplicate", id: string): void;
  (event: "archive", id: string): void;
};

export const useCatalog = () => {
  const headers = useState<IIndexHeader[]>(() => [
    {
      name: "Formation",
      sort: true,
      key: "title",
      minWidthPx: 250,
      maxWidthFr: 1,
      visible: true,
      scope: SettingScopesEnum.CompanyCatalogTab,
    },
    {
      name: "Prestataire",
      sort: true,
      key: "training_partner_name",
      minWidthPx: 134,
      maxWidthFr: 1,
      visible: true,
      scope: SettingScopesEnum.CompanyCatalogTab,
    },
    {
      name: "Catégorie",
      sort: true,
      key: "categories",
      minWidthPx: 210,
      maxWidthFr: 1,
      visible: true,
      scope: SettingScopesEnum.CompanyCatalogTab,
    },
    {
      name: "Type",
      sort: true,
      key: "session_items_types",
      minWidthPx: 93,
      maxWidthFr: 1,
      visible: true,
      scope: SettingScopesEnum.CompanyCatalogTab,
    },
    {
      name: "Prix (HT)",
      sort: true,
      key: "default_price",
      minWidthPx: 80,
      maxWidthFr: 1,
      visible: true,
      scope: SettingScopesEnum.CompanyCatalogTab,
    },
    {
      name: "Format",
      sort: true,
      key: "format",
      minWidthPx: 100,
      maxWidthFr: 1,
      visible: true,
      scope: SettingScopesEnum.CompanyCatalogTab,
    },
    {
      name: "Durée",
      sort: true,
      key: "duration_hours",
      minWidthPx: 70,
      maxWidthFr: 1,
      visible: true,
      scope: SettingScopesEnum.CompanyCatalogTab,
    },
    {
      name: "Visible",
      sort: false,
      key: "only_visible",
      minWidthPx: 85,
      maxWidthFr: 1,
      visible: true,
      scope: SettingScopesEnum.CompanyCatalogTab,
    },
    {
      name: "Source",
      sort: true,
      key: "is_company_training",
      minWidthPx: 85,
      maxWidthFr: 1,
      visible: true,
      scope: SettingScopesEnum.CompanyCatalogTab,
    },
    {
      name: "Tag formation",
      sort: false,
      key: "training_tags",
      minWidthPx: 180,
      maxWidthFr: 1,
      visible: true,
      scope: SettingScopesEnum.CompanyCatalogTab,
    },
    {
      name: "",
      sort: false,
      key: "actions",
      minWidthPx: 80,
      maxWidthFr: 1,
      visible: true,
      scope: SettingScopesEnum.CompanyCatalogTab,
    },
  ]);

  const getRowActions = (emit: CatalogRowActionsEmit) => [
    { name: "Modifier", icon: "edit", function: (id: string) => emit("edit", id) },
    { name: "Dupliquer", icon: "duplicate", function: (id: string) => emit("duplicate", id) },
    { name: "Archiver", icon: "delete_trash", function: (id: string) => emit("archive", id) },
  ];

  return { headers, getRowActions };
};
